var React = require('react');

function SmileyNeutralLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 48a24 24 0 110-48 24 24 0 010 48zm0-46a22 22 0 100 44 22 22 0 000-44z","key":0}),React.createElement("path",{"d":"M33 34H15a1 1 0 010-2h18a1 1 0 110 2zM16.5 21.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm15 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","key":1})]);
}

SmileyNeutralLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SmileyNeutralLight;

SmileyNeutralLight.default = SmileyNeutralLight;
